"use client"
import { Container } from "@mui/material"
import { SiteMapPageDto } from "api"
import BreadCrumbsWrapper from "common/BreadCrumbs"
import { useIsDesktop } from "common/MediaQueries"
import slugify from "common/bit/utils/slugify"
import usePrivacyPolicyLink from "hooks/usePrivacyPolicyLink"
import { useEffect, useState } from "react"
import styled from "styled-components"
import { StyledPageWrapper } from "theme/shared"
import { StyledHeaderH1 } from "../../../reusable/wrappers/CenterText"
import ImageContainer from "../../../reusable/wrappers/ImageContainer"
import SitemapLinks from "./SitemapLinks"

const StyledPageDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  display: flex;
  align-items: center;
  background: ${(p) => p.theme.colors.lightGrey};
  padding-bottom: 80px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    align-items: start;
    h2 {
      padding-right: 15px;
    }
  }
`

const StyledLinkWrapper = styled(Container)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 40px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-direction: column;
    margin-top: 0px;
  }
`

type SiteMapPageProps = {
  data: SiteMapPageDto
}

const service = [
  { link: "/services-centers", text: "מרכזי שירות" },
  { link: "/recall", text: "קריאה חוזרת (Recall)" },
  { link: "/service-instructions", text: "הוראת שירות" },
  { link: "/warranty-extension", text: "בדיקת תוחלת הארכת אחריות" },
  { link: "/warranty", text: "כתב אחריות" },
  { link: "/spare-price-list", text: "מחירון מוצרי תעבורה (חלפים)" },
  { link: "/color-code", text: "בדיקת קוד צבע" },
  {
    text: "תוכנית טיפול",
    link: "/service-plans",
  },
  { link: "/hamesayat", text: "המסייעת" },
  {
    text: "סרטוני הדרכה",
    link: "/video-tutorials",
  },
]

const purchase = [
  { link: "/show-rooms", text: "אולמות תצוגה" },
  { link: "/car-list", text: "מחירון רכב" },
  { link: "/insurance", text: "ביטוח" },
  { link: "/car-fleets", text: "ציי רכב" },
]

const homepage = [
  { link: "/", text: "דף הבית" },
  { link: "/sitemap", text: "מפת אתר" },
]

const contactUs = [{ link: "/contact-us", text: "יצירת קשר" }]

const calculator = [{ link: "/models/finance", text: "מחשבון מימון" }]

const demoRide = [{ link: "/test-drive", text: "הזמנת נסיעת הדגמה" }]

const SitemapPage = ({ data }: SiteMapPageProps) => {
  const privacyPolicyLink = usePrivacyPolicyLink()
  const about = [
    { link: privacyPolicyLink, text: "מדיניות פרטיות" },
    { link: "/terms-of-use", text: "תנאי שימוש" },
    { link: "/accessibility", text: "הצהרת נגישות" },
  ]
  const [carData, setCarData] = useState<Array<{ link: string; text: string }>>(
    []
  )
  const isDesktop = useIsDesktop()

  useEffect(() => {
    const arr: Array<{ link: string; text: string }> = []
    data.carModels.map((car) =>
      arr.push({ link: getCarLink(car), text: car.name })
    )
    setCarData(arr)
  }, [data])

  const getCarLink = (car) => {
    const carLink = `/model/[modelId]/[modelSlug]`
      .replace("[modelId]", car.id.toString())
      .replace("[modelSlug]", slugify(car.name))
    return carLink
  }

  return (
    <StyledPageWrapper $padding={"0"}>
      <StyledPageDiv>
        <ImageContainer
          src={isDesktop ? "/img/map.jpg" : "/img/mapmobile.jpg"}
        />
        <BreadCrumbsWrapper name="SiteMap" />
        <StyledHeaderH1 $margin={45}>מפת אתר</StyledHeaderH1>
        <StyledLinkWrapper>
          <SitemapLinks links={homepage} title="דף הבית" />
          <SitemapLinks links={carData} title="לכל הדגמים" fontSize={16} />
          <SitemapLinks links={purchase} title="רכישה" />
          <SitemapLinks links={service} title="שירות" />
          <SitemapLinks links={about} title="אודות" margin={true} />
          <SitemapLinks
            links={demoRide}
            title="הזמנת נסיעת הדגמה"
            margin={true}
          />
          <SitemapLinks links={calculator} title="מחשבון מימון" margin={true} />
          <SitemapLinks links={contactUs} title="יצירת קשר" margin={true} />
        </StyledLinkWrapper>
      </StyledPageDiv>
    </StyledPageWrapper>
  )
}

export default SitemapPage
